<template>

</template>

<script>

    import responsiveImage from 'components/image/responsiveImage.vue'

    export default {
        components: {
            responsiveImage
        },
        data() {
            return {
                galleryImages: [],
                galleryLinks: []
            };
        },
        mounted() {
            this.galleryImages = Array.from(document.querySelectorAll(".gallery-image"));
            this.galleryLinks = Array.from(document.querySelectorAll(".gallery-link"));

            /**
             * IE 11 & Edge do not recognize :focus in CSS
             * The solution to make keyboard tab navigation possible
             * is to bind the javascript focus & blur events
             */
            let self = this
            this.galleryLinks.forEach(link => {
                link.addEventListener('focus', function () {
                    this.classList.add('active')
                    self.setActiveElement(this.getAttribute('data-uid'))
                })
                link.addEventListener('blur', function () {
                    this.classList.remove('active')
                })
            })

            /**
             * Set each images max-height to the gallery-container height
             * This way also the portrait images do not increase the height of the whole component and do not cause jumping
             *
             */
            let hoverGalleryHeight = 0
            Array.from(document.getElementById('gallery-links-container').children).forEach(child => {
                hoverGalleryHeight += child.offsetHeight
            })
            this.galleryImages.forEach(image => {
                image.style.maxHeight = hoverGalleryHeight + 'px';
            })


        },
        methods: {
            setActiveElement(uid) {
                this.galleryImages.forEach(image => {
                    if(image.getAttribute("data-uid") == uid) {
                        image.classList.remove('hidden')
                    } else {
                        image.classList.add('hidden')
                    }
                })

                this.galleryLinks.forEach(link => {
                    if(link.getAttribute("data-uid") == uid) {
                        link.classList.add('active')
                    } else {
                        link.classList.remove('active')
                    }
                })
            }
        }
    }

</script>

<style rel="stylesheet/scss" lang="scss" type="text/css" scoped>
    .focus {
        color: theme('colors.primarycolor');
    }

    .gallery-link {
        &.active, &:hover {
            color: theme('colors.primarycolor');
        }
    }

    img.hidden {
        display: none !important;
    }

    .portrait {
        width:auto !important;
        margin:auto;
    }

</style>
